import * as React from 'react';
import { ErrorNotification, SuccessNotification } from '@verclam/toast-v2';

/**
 * `eventName` matches the `type` of the actions dispatched by `saveModelAssignment` and
 * `clearModelAssignment`, from `UsageAssignmentCardActions` — the only place in the app that fires
 * them, shared by all three affectation screens — and by `saveUsageSettings`, fired from
 * `UsageSettingsSidebar` and `UsageSettingsResetAction`. Mounted by each of the three (account,
 * organization, facility): only one screen is ever mounted at a time, the same reasoning as
 * `AiEnginesNotifications` for the provider/catalog actions it still owns.
 */
const AiAssignmentsNotifications: React.FC = () => {
	return (
		<React.Fragment>
			<SuccessNotification
				eventName="MODEL_ASSIGNMENT_SAVED"
				title="Affectation enregistrée"
				message="L’affectation de cet usage a bien été enregistrée."
			/>
			<SuccessNotification
				eventName="MODEL_ASSIGNMENT_CLEARED"
				title="Affectation retirée"
				message="L’usage suit de nouveau le niveau au-dessus."
			/>
			<ErrorNotification
				eventName="MODEL_ASSIGNMENT_SAVE_FAILED"
				title="Erreur"
				message="L’affectation n’a pas pu être enregistrée."
			/>
			<ErrorNotification
				eventName="MODEL_ASSIGNMENT_CLEAR_FAILED"
				title="Erreur"
				message="L’affectation n’a pas pu être retirée."
			/>
			<SuccessNotification
				eventName="USAGE_SETTINGS_SAVED"
				title="Réglages enregistrés"
				message="Les réglages d’appel de cet usage ont bien été enregistrés."
			/>
			<ErrorNotification
				eventName="USAGE_SETTINGS_SAVE_FAILED"
				title="Erreur"
				message="Les réglages d’appel n’ont pas pu être enregistrés."
			/>
		</React.Fragment>
	);
};

export default AiAssignmentsNotifications;
